/**
 * Функция проверяющая, что ошибка вызвана отсутствием необходимых чанков на сервере (приложение обновилось)
 */
function checkChunkLoadError(error: Error) {
  return String(error).includes("ChunkLoadError");
}

export default checkChunkLoadError;
